export default $ => {
  $('[href^="#"]').not('[href^="#modal"]').click(function (event) {
    if ($(this).attr('href') === '#') {
      return;
    }
    
    event.preventDefault();

    const target = $($(this).attr('href'));
    if (target.length > 0) {
      let targetTop = $(target).offset().top;

      const padTarget = $(this).data('pad-scroll');
      if (padTarget) {
        const padding = $(padTarget).height();
        targetTop -= padding;
      }

      $('html, body').animate({
        scrollTop: targetTop,
      }, 500);
    }
  });
};



// WEBPACK FOOTER //
// ./assets/js/component/scroll/smooth-scroll.js